module.exports = __webpack_public_path__ + "static/media/cia_triad.1007fa7b.jpg";